import { DataLayerManagerInterface } from './dataLayerManager/abstractDataLayerManager';
import { DataLayerItem } from 'Common/appshell_types/trackingHelpers';

enum RATING_OVERLAY_EVENTS {
    SHOWN_OVERLAY = 'reviewsEvent-reminderOverlayShow',
    DISMISSED_VERLAY = 'reviewsEvent-reminderOverlayClose',
    REVIEW_BUTTON_CLICKED = 'reviewsEvent-reviewsOverlayButtonClick',
    RATINGS_COMPONENT_CLICKED = 'reviewsOverlayStarsClick',
}
export default class ProductRatingsOverlayTracker {
    private dataLayerManager: DataLayerManagerInterface;

    public constructor(dataLayerManager: DataLayerManagerInterface) {
        this.dataLayerManager = dataLayerManager;
    }

    public trackRatingOverlayShown(options: DataLayerItem) {
        this.dataLayerManager.sendEvent(RATING_OVERLAY_EVENTS.SHOWN_OVERLAY, options);
    }

    public trackRatingsComponentClicked(options: DataLayerItem) {
        this.dataLayerManager.sendEvent(RATING_OVERLAY_EVENTS.RATINGS_COMPONENT_CLICKED, options);
    }

    public trackReviewButtonClicked(options: DataLayerItem) {
        this.dataLayerManager.sendEvent(RATING_OVERLAY_EVENTS.REVIEW_BUTTON_CLICKED, options);
    }

    public trackRatingOverlayDismissed(options: DataLayerItem) {
        this.dataLayerManager.sendEvent(RATING_OVERLAY_EVENTS.DISMISSED_VERLAY, options);
    }
}
